export const statusIsGood = status => status >= 200 && status < 300;
export const statusIsUnauthorized = status => status === 401;

export const stringIsEmptyOrNull = str => str == null || str === '';

export const getSlugFromName = str => (str ? str.toLowerCase().split(' ').join('_') : null);

export const getLocalStorageItem = key => {
  try {
    const result = localStorage.getItem(key);
    return result;
  } catch {
    return null;
  }
};

export const setLocalStorageItem = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch {
    // since we only use this as a backup to in-memory state, don't need additional action on error
  }
};

// Connects two items by "&", and 3+ items by "__, __, ... __, & __"
export const prettyEnglishList = (strList, allLowerCase) => {
  if (!strList || strList.length === 0) {
    return null;
  }
  if (strList.length === 1) {
    return strList[0];
  }
  // make a new list where all but the first item are converted to lowercase
  const newList = strList.map((item, idx) => {
    if (idx === 0 && !allLowerCase) {
      return item;
    }
    return item.toLowerCase();
  });
  const last = newList.pop();
  return newList.join(', ') + ' & ' + last;
};

export const getRandomInt = max => Math.floor(Math.random() * max);

export const makeRandomId = length => {
  var result = '';
  var characters = '0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const isValidEmail = email => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);

export const capitalizeFirstLetter = str => {
  return String(str).charAt(0).toUpperCase() + String(str).slice(1);
};

export const pluralize = (word, array) => {
  return array.length > 1 ? word + 's' : word;
};

export const hexToRgb = hex => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : { r: 6, g: 182, b: 212 }; // default cyan
};
